import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';

/**
 * Compact statistic widget. The value is the focal point — the icon is a quiet
 * marker in the corner, never a coloured tile.
 */
const StatCard = ({
    label,
    value,
    icon: Icon,
    tone = 'neutral',
    trend,            // { value: '5%', direction: 'up' | 'down', label: 'vs last month' }
    caption,          // plain secondary line, used when there is no trend
    to,
    className = '',
}) => {
    const tones = {
        neutral: 'text-ink-500',
        primary: 'text-primary-600',
        success: 'text-success',
        warning: 'text-warning',
        danger: 'text-danger',
        info: 'text-info',
    };

    const positive = trend?.direction === 'up';
    const TrendIcon = positive ? ArrowUpRight : ArrowDownRight;
    const trendTone = trend
        ? trend.good === false || (trend.good === undefined && !positive)
            ? 'text-danger'
            : 'text-success'
        : '';

    const body = (
        <>
            <div className="flex items-start justify-between gap-3">
                <p className="text-label font-medium text-ink-600 uppercase tracking-wide">
                    {label}
                </p>
                {Icon && <Icon size={17} className={tones[tone] || tones.neutral} aria-hidden="true" />}
            </div>
            <p className="text-[26px] leading-none font-semibold text-ink-900 tabular mt-3">
                {value ?? 0}
            </p>
            <div className="mt-auto pt-3 flex items-center gap-1.5 min-h-[18px]">
                {trend ? (
                    <>
                        <span className={`inline-flex items-center gap-0.5 text-label font-semibold ${trendTone}`}>
                            <TrendIcon size={13} aria-hidden="true" />
                            {trend.value}
                        </span>
                        {trend.label && <span className="text-label text-ink-500">{trend.label}</span>}
                    </>
                ) : (
                    caption && <span className="text-label text-ink-500 truncate">{caption}</span>
                )}
            </div>
        </>
    );

    const classes = `card card-hover flex flex-col p-4 min-h-[124px] ${to ? 'block' : ''} ${className}`;

    return to ? (
        <Link to={to} className={classes}>
            {body}
        </Link>
    ) : (
        <div className={classes}>{body}</div>
    );
};

export default StatCard;
